<template>
  <div>
    <v-app>
      <v-app-bar app>
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-spacer></v-spacer>
        <v-header></v-header>
      </v-app-bar>

      <v-navigation-drawer class="navigation-drawer-class" width="200" app v-model="drawer" temporary
                           :mini-variant="isModel">
        <v-aside></v-aside>
        <!--        <template v-slot:append>-->
        <!--          <div class="pa-2">-->
        <!--            <v-btn @click="switchover"-->
        <!--                   :icon="isModel" :block="!isModel">-->
        <!--              <div v-if="isModel">-->
        <!--                <v-icon v-if="getDarker">brightness_high</v-icon>-->
        <!--                <v-icon v-else>brightness_4</v-icon>-->
        <!--              </div>-->
        <!--              <div v-else>-->
        <!--                <span>{{ getDarker ? '标准模式' : '夜间模式' }}</span>-->
        <!--              </div>-->
        <!--            </v-btn>-->
        <!--          </div>-->

        <!--          <div class="pa-2">-->
        <!--            <v-btn-->
        <!--                :disabled="getDarker"-->
        <!--                @click="switchoverBackground"-->
        <!--                :icon="isModel" :block="!isModel">-->
        <!--              <div v-if="isModel">-->
        <!--                <v-icon v-if="getBackground && !getDarker">image_not_supported</v-icon>-->
        <!--                <v-icon v-else>image</v-icon>-->
        <!--              </div>-->
        <!--              <div v-else>-->
        <!--                <span>{{ getBackground ? '取消背景' : '设置背景' }}</span>-->
        <!--              </div>-->
        <!--            </v-btn>-->
        <!--          </div>-->

        <!--          <div class="pa-2">-->
        <!--            <v-btn-->
        <!--                @click="showNotice"-->
        <!--                :icon="isModel" :block="!isModel">-->
        <!--              <div v-if="isModel">-->
        <!--                <v-icon>update</v-icon>-->
        <!--              </div>-->
        <!--              <div v-else>-->
        <!--                <span>更新日志</span>-->
        <!--              </div>-->
        <!--            </v-btn>-->
        <!--          </div>-->
        <!--        </template>-->
      </v-navigation-drawer>

      <!-- 根据应用组件来调整你的内容 -->
      <v-main class="pt-0">
        <v-content @move="moveNavigation" :model="isModel"></v-content>
        <v-container fluid class="container-class pt-16" :class="!getDarker ? 'darker-class':''">
          <router-view :key="$route.fullPath"/>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import Aside from './Aside/index';
import Header from './Header/index';
import Content from './Content/index'

export default {
  data: () => ({
    drawer: false,
  }),
  mounted() {
    this.dark();
  },
  components: {
    'v-aside': Aside,
    'v-header': Header,
    'v-content': Content
  },
  computed: {
    ...mapGetters(['getDarker', 'getBackground']),
    isModel() {
      return this.$vuetify.breakpoint.name === 'xs'
    }
  },
  methods: {
    ...mapMutations(['setDarker', 'setBackground', 'setBackground']),
    switchover() {
      this.setDarker(!this.getDarker)
      this.dark()
    },
    dark() {
      this.$vuetify.theme.dark = this.getDarker
    },
    switchoverBackground() {
      if (!this.getDarker) {
        this.setBackground(!this.getBackground)
      }
    },
    moveNavigation(val) {
      this.drawer = val;
    },
    showNotice() {
      this.$router.push({
        path: '/notice/index',
        query: {keyword: this.keyword}
      })
    },
  }
}
</script>

<style scoped>
.navigation-drawer-class {
  z-index: 6;
}

.container-class {
  padding: 0;
  height: 100%;
  width: 100%;
}

.darker-class {
  background-color: #f6f6f6;
}
</style>
